module.exports = __webpack_public_path__ + "img/info.51c11a71.svg";